/**
 * @flow
 * @format
 */

/**
 * Old index.js file - until I figure out how to rename the CRA entry point.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Container } from 'reactstrap';
import ScrollToTop from 'react-scroll-up';
import FaArrowCircleOUp from 'react-icons/lib/fa/arrow-circle-o-up';
import Aux from '~/utils/react-aux';

import Header from './components/Header';
import Footer from './components/Footer';
import ModalWrapper from './components/ModalWrapper';
// import registerServiceWorker from './registerServiceWorker';
import App from './App';

// Import the index reducers, sagas, and middlware
import IndexSagas from './sagas';
import configureStore from './configureStore';

const store = configureStore();

// Begin our Index Saga $FlowIgnore
store.run(IndexSagas);

const scrollStyle = {
  position: 'fixed',
  bottom: 50,
  right: 30,
  cursor: 'pointer',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'linear',
  transitionDelay: '0s',
  zIndex: 9990,
};

const AppWrapper = (BaseComponent, localStore) => (
  <Provider store={localStore}>
    <Aux>
      <ScrollToTop showUnder={160} style={scrollStyle}>
        <span>
          <FaArrowCircleOUp size={80} />
        </span>
      </ScrollToTop>
      <Header title={process.env.REACT_APP_TOOL_NAME} />
      <Container fluid>
        <BaseComponent />
        <footer className="row">
          <Footer />
        </footer>
        <ModalWrapper />
      </Container>
    </Aux>
  </Provider>
);

const rootEl = document.getElementById('root');

if (!rootEl) {
  throw Error('Missing root element');
}

ReactDOM.render(AppWrapper(App, store), rootEl);

// registerServiceWorker();

if (module.hot) {
  /* eslint-disable global-require */
  // $FlowIgnore
  module.hot.accept();
  // module.hot.accept('./App', () => {
  //   const NextApp = require('./App').default;
  //   ReactDOM.render(AppWrapper(NextApp, store), rootEl);
  // });
  // // Enable Webpack hot module replacement for reducers
  // module.hot.accept('./reducers', () => {
  //   const nextReducer = require('./reducers').default;
  //   store.replaceReducer(nextReducer);
  // });
  /* eslint-enable global-require */
}



// WEBPACK FOOTER //
// ./src/main.js